<template>
    <div>
        <v-list-item :value="item" style="min-height: 55px;padding:0;">
            <template>
                <v-list-item-content style="margin:0;">
                    <v-col>
                        <p style="font-size: 1.0rem; margin: 0; color: #666;">
                            {{ item.flightNo }}
                        </p>
                    </v-col>
                    <v-col>
                        <p style="font-size: 1.0rem; margin: 0; color: #666;">
                            {{ item.leg }}
                        </p>
                    </v-col>
                     <v-col style="display:flex;">
                        <div style="display: flex; flex-direction: column; margin-right: 8px; margin-left:4px; font-size: 1.0rem">
                            <p style="font-size: 1.0rem; margin: 0; color: #666;">
{{ $dayjsLocalToUTC(item.dep_sch_time) }}<sup> UTC</sup>
</p>
                            <div v-if="item.dep_slt_time" style="color:#aaa;display:flex;">
                                <v-icon style="font-size: 1.0rem; color: #aaa;">
mdi-subdirectory-arrow-right
</v-icon>
                                <p style="font-size: 1.0rem; margin: 0; color: #666;">
{{ $dayjsLocalToUTC(item.dep_slt_time) }}<sup> UTC</sup>
</p>
                            </div>
                        </div>
                        <div style="display: flex;flex-direction: column;align-items: end;margin-right: 8px;">
                            <div>-</div>
                        </div>
                        <div style="display: flex; flex-direction: column; margin-right: 8px; margin-left:4px; font-size: 1.0rem">
                            <p style="font-size: 1.0rem; margin: 0; color: #666;">
{{ $dayjsLocalToUTC(item.arr_sch_time) }}<sup> UTC</sup>
</p>
                            <div v-if="item.arr_slt_time" style="color:#aaa;display:flex;">
                                <v-icon style="font-size: 1.0rem; color: #aaa;">
mdi-subdirectory-arrow-right
</v-icon>
                                <p style="font-size: 1.0rem; margin: 0; color: #666;">
{{ $dayjsLocalToUTC(item.arr_slt_time) }}<sup> UTC</sup>
</p>
                            </div>
                        </div>
                    </v-col>
                    <v-col>
                        <p style="font-size: 1.0rem; margin: 0; color: #666;">
                            {{ $dayjsLocalToUTC(item.departureTime, 'dd, DD.MM.YY') }}
                        </p>
                    </v-col>
                    <v-col>
                        <p style="font-size: 1.0rem; margin: 0; color: #666;">
                          {{ item.flightType }}
                        </p>
                    </v-col>
                </v-list-item-content>
            </template>
        </v-list-item>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';


    export default {
        name: 'Selectedflightslistitem', // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {},

        /* >>> *************************************************************** / /* Props */
        props: {

            item: Object

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {};

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([])

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function () {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/SelectedFlightListItem.vue >>> created');

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function () {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/SelectedFlightListItem.vue >>> destroyed');

        }, // eo function destroyed()



        /* >>> *************************************************************** / /* Methods */
        methods: {


            /******************************************************************* ''
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_ClassForEditedRow()
            *
            * Desc: Returns selected Class if Row was edited (prop: 'wasEdited')
            * Note:
            *
            */
			get_ClassForEditedRow: function(item) {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/flights/SelectedFlightsListItem.vue >>> get_ClassForEditedRow');
				return item.legInfo.wasEdited === true ? 'rowWasEdited' : '';

			} // eo function get_ClassForEditedRow()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style scoped>
    .v-card .v-divider {
        border-color: #d2d2d2;
    }

    .v-list-item {
        padding: 0 26px;
    }
    .rowWasEdited {
        /* border-left: 4px solid #AB3B7C;
        padding-left: 4px; */
        /* background-color: #AB3B7C; */
        border: 2px solid #AB3B7C;
        padding: 2px;
	}
</style>
